import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import {
    getPAJAC020TaskManager,
    postPAJAC010,
    postPAJAC010CloneReady,
    postPAJAC010Delete,
    putPAJAC010Clone,
    putPAJAC010Expired,
    putPAJAC010JumpUp,
    putPAJAC010Reset,
} from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import RecruitmentStatus from '../../../shared/components/RecruitmentStatus';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';
import { MESSAGE } from '../../../shared/constants/app';
const PAJAC010 = () => {
    const [statistics, setStatistics] = useState({});
    const [dataRecruit, setDataRecruit] = useState([]);
    const printRef = useRef();
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [statusFlag, setStatusFlag] = useState(['']);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const navigate = useNavigate();
    const codeLists = {
        A11: [],
    };

    const isActiveTab = (flag) => {
        if (flag.length === 0) {
            return statusFlag.length === 0 || statusFlag.includes('');
        }
        return flag.some((f) => statusFlag.includes(f));
    };

    const handleActiveTab = (statusFlag) => {
        setStatusFlag(statusFlag);
        setSearchParams({ ...searchParams, page: 1 });
        getListData(statusFlag, startDate, endDate);
    };

    const getListData = (currentStatusFlag = statusFlag, inputStartDate = startDate, inputEndDate = endDate) => {
        const startDateFormat = inputStartDate ? moment(inputStartDate).format('YYYY-MM-DD') : null;
        const endDateFormat = inputEndDate ? moment(inputEndDate).format('YYYY-MM-DD') : null;

        const payload = {
            page,
            startDate: startDateFormat,
            endDate: endDateFormat,
        };

        if (currentStatusFlag.length > 0 && currentStatusFlag[0] !== '') {
            payload.options = { statusFlag: currentStatusFlag };
        }

        fetchTaskManager();
        postPAJAC010(payload)
            .then(async ({ data }) => {
                setStatistics(data.data.statistics);
                setPages(data.info || {});
                setDataRecruit(
                    Array.isArray(data.data.list)
                        ? data.data.list?.map((item) => ({
                              ...item,
                              recruitClass: getCodeName(item.recruitClass, 'A11'),
                          }))
                        : [],
                );
            })
            .catch((error) => console.error(error));
    };

    const handleSearchDateRange = (startDateFormat, endDateFormat) => {
        const newStartDate = startDateFormat ? moment(startDateFormat, 'YYYY-MM-DD').toDate() : null;
        const newEndDate = endDateFormat ? moment(endDateFormat, 'YYYY-MM-DD').toDate() : null;

        setStartDate(newStartDate);
        setEndDate(newEndDate);

        getListData(statusFlag, newStartDate, newEndDate);
    };

    const handleResetViewCount = (seq) => {
        putPAJAC010Reset(seq)
            .then(() => {
                getListData();
                window.alert('조회수를 초기화되었습니다.');
            })
            .catch((error) => console.log(error));
    };

    const handleClone = (seq) => {
        putPAJAC010Clone(seq)
            .then(() => {
                getListData();
                window.alert('복사 완료되었습니다.');
            })
            .catch((error) => console.log(error));
    };

    const handleCloneReady = (seq) => {
        postPAJAC010CloneReady(seq)
            .then(() => {
                getListData();
                window.alert('복사 완료되었습니다.');
            })
            .catch((error) => console.log(error));
    };

    const handleJumpUp = (seq) => {
        putPAJAC010JumpUp(seq)
            .then(() => {
                getListData();
                window.alert(MESSAGE.notify.updateSuccess);
            })
            .catch((error) => console.log(error));
    };

    const handleExpired = (seq) => {
        if (window.confirm('채용 공고를 마감하시겠습니까?')) {
            putPAJAC010Expired(seq)
                .then(() => {
                    getListData();
                    window.alert(MESSAGE.notify.updateSuccess);
                })
                .catch((error) => console.log(error));
        }
    };

    const handleDelete = (flag, seq) => {
        if (window.confirm('삭제하시겠습니까?')) {
            postPAJAC010Delete(flag, seq)
                .then(() => {
                    getListData();
                    window.alert('삭제되었습니다.');
                })
                .catch((error) => console.log(error));
        }
    };

    const handleOption = (type, seq) => {
        navigate(`/pajac020-${seq}?step=2&type=${type}&option=true`);
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    async function fetchTaskManager() {
        try {
            await getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
        } catch (error) {
            console.error(error);
        }
    }
    // Hàm getCodeName
    const getCodeName = (codes, key) => {
        const list = codeLists[key]; // Lấy danh sách tương ứng với key
        const transformed = (codes || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null
        if (!list) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = list.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = list.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = list?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };
    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume" ref={printRef}>
                            <div className="resume__inner">
                                <h3 className="resume__tit">채용정보 관리/영수증</h3>
                                <div className="rsm-mng">
                                    <div className="rsm-mng__btbx">
                                        <Link to="/pajac020" className="rsm-mng__btn">
                                            채용공고 등록
                                        </Link>
                                    </div>
                                </div>
                                <SearchDateRange
                                    handleSearchDateRange={handleSearchDateRange}
                                    setSearchParams={setSearchParams}
                                />
                                <div className="mtch">
                                    <div
                                        className="mtch__block repeat-5"
                                        style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}
                                    >
                                        <Link
                                            onClick={() => handleActiveTab([''])}
                                            className={`mtch__cnd ${isActiveTab(['']) ? 'active' : ''}`}
                                        >
                                            전체 ({statistics?.total ? statistics?.total : 0})
                                        </Link>
                                        <Link
                                            onClick={() => handleActiveTab(['K'])}
                                            className={`mtch__cnd ${statusFlag.includes('K') ? 'active' : ''}`}
                                        >
                                            보관중인 공고 ({statistics?.totalK ? statistics?.totalK : 0})
                                        </Link>
                                        <Link
                                            onClick={() => handleActiveTab(['O'])}
                                            className={`mtch__cnd ${statusFlag.includes('O') ? 'active' : ''}`}
                                        >
                                            게재중인 공고 ({statistics?.totalO ? statistics?.totalO : 0})
                                        </Link>
                                        <Link
                                            onClick={() => handleActiveTab(['P', 'V'])}
                                            className={`mtch__cnd ${
                                                statusFlag.includes('P') || statusFlag.includes('V') ? 'active' : ''
                                            }`}
                                        >
                                            입금 대기 공고 ({statistics?.totalP ? statistics?.totalP : 0})
                                        </Link>
                                        <Link
                                            onClick={() => handleActiveTab(['C', 'D', 'E'])}
                                            className={`mtch__cnd ${
                                                statusFlag.includes('C') ||
                                                statusFlag.includes('D') ||
                                                statusFlag.includes('E')
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            마감 공고 ({statistics?.totalExpired ? statistics?.totalExpired : 0})
                                        </Link>
                                        {/* <Link
                                            onClick={() => handleActiveTab(['J'])}
                                            className={`mtch__cnd ${statusFlag.includes('J') ? 'active' : ''}`}
                                        >
                                            거절 ({statistics?.totalJ ? statistics?.totalJ : 0})
                                        </Link> */}
                                    </div>
                                </div>
                                <RecruitmentStatus
                                    dataRecruit={dataRecruit}
                                    handleJumpUp={handleJumpUp}
                                    handleResetViewCount={handleResetViewCount}
                                    handleExpired={handleExpired}
                                    handleClone={handleClone}
                                    handleDelete={handleDelete}
                                    handleCloneReady={handleCloneReady}
                                    handleOption={handleOption}
                                />
                                <Pagination pages={pages} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PAJAC010;
